<template>
  <div class="row text-primary">
    <div class="col-12 ">
      <div class="row">
        <div class="border rounded shadow card col-12 border-0 p-0">
          <div class="card-header bg-primary text-white m-0">
            <i class="fa fa-search"></i>
            <i class="fa fa-user pr-3"></i> Mitgliedersuche
          </div>
          <div class="p-3">
            <div class="form">
              <div class="form-group pt-2">
                <label for="searchBoxInputSex">Suche nach</label>
                <sex-selector v-model="gender"></sex-selector>
              </div>
              <div class="form-group">
                <age-slider :value="age" v-model="age"></age-slider>
              </div>
              <div class="form-group">
                <label for="searchBoxInputTown"> Aus: Ort (PLZ)</label>
                <autocomplete
                  class="user-search"
                  id="searchBoxInputTown"
                  v-model="postcode"
                  inputClass="form-control"
                  url="/api/v1/register/validate-step/1/autocomplete"
                  requestType="get"
                  property="location"
                  :threshold="2"
                  @click.native="checkAuth"
                ></autocomplete>
              </div>
              <distance-slider v-model="distance"></distance-slider>
              <div class="form-group">
                <div class="form-row">
                  <div class="col-xxl-6">
                    <div class="custom-control custom-checkbox">
                      <input
                        @click="checkAuth"
                        class="custom-control-input"
                        type="checkbox"
                        id="searchBoxCheckOnlineStatus"
                        v-model="isOnline"
                      />
                      <label
                        class="custom-control-label"
                        for="searchBoxCheckOnlineStatus"
                      >
                        Nur Online
                      </label>
                    </div>
                  </div>
                  <div class="col-xxl-6">
                    <div class="custom-control custom-checkbox">
                      <input
                        @click="checkAuth"
                        type="checkbox"
                        class="custom-control-input"
                        id="searchBoxCheckPicture"
                        v-model="hasPicture"
                      />
                      <label
                        class="custom-control-label"
                        for="searchBoxCheckPicture"
                      >
                        Nur mit Bilder
                      </label>
                    </div>
                  </div>
                </div>
                <div class="custom-control custom-checkbox pt-0">
                  <input
                    @click="checkAuth"
                    v-model="hasEroticPicture"
                    class="custom-control-input"
                    type="checkbox"
                    value=""
                    id="searchBoxCheckEroticPicture"
                  />
                  <label
                    class="custom-control-label"
                    for="searchBoxCheckEroticPicture"
                    >Nur Erotikprofile</label
                  >
                </div>
              </div>
              <div class="form-group">
                <div class="custom-control custom-radio pt-0">
                  <input
                    @click="checkAuth"
                    v-model="order"
                    class="custom-control-input"
                    type="radio"
                    value="newest"
                    id="searchBoxRadioOrderNewestMember"
                  />
                  <label
                    class="custom-control-label"
                    for="searchBoxRadioOrderNewestMember"
                    >Neuste Mitglieder zuerst</label
                  >
                </div>
                <div class="custom-control custom-radio pt-0">
                  <input
                    @click="checkAuth"
                    v-model="order"
                    class="custom-control-input"
                    type="radio"
                    value="nearest"
                    id="searchBoxRadioOrderNearestMember"
                  />
                  <label
                    class="custom-control-label"
                    for="searchBoxRadioOrderNearestMember"
                    >Naheste Mitglieder zuerst</label
                  >
                </div>
                <div class="custom-control custom-radio pt-0">
                  <input
                    @click="checkAuth"
                    v-model="order"
                    class="custom-control-input"
                    type="radio"
                    value="oldest"
                    id="searchBoxRadioOrderOldestMember"
                  />
                  <label
                    class="custom-control-label"
                    for="searchBoxRadioOrderOldestMember"
                    >Neuste Mitglieder zuletzt</label
                  >
                </div>
                <div class="custom-control custom-radio pt-0">
                  <input
                    @click="checkAuth"
                    v-model="order"
                    class="custom-control-input"
                    type="radio"
                    value="farthest"
                    id="searchBoxRadioOrderFarthestMember"
                  />
                  <label
                    class="custom-control-label"
                    for="searchBoxRadioOrderFarthestMember"
                    >Naheste Mitglieder zuletzt</label
                  >
                </div>
              </div>
              <button
                type="submit"
                @click="checkAuth($event, applySearch)"
                class="btn btn-primary rounded mb-2 float-right"
                :disabled="searching"
              >
                Suche
                <i v-if="searching" class="fa fa-spin fa-spinner"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SexSelector from "./search/SexSelector.vue";
import AgeSlider from "./search/AgeSlider.vue";
import DistanceSlider from "./search/DistanceSlider.vue";
import Autocomplete from "autocomplete-vue";

export default {
  components: {
    SexSelector,
    AgeSlider,
    DistanceSlider,
    Autocomplete
  },
  data() {
    return {
      searching: false,
      genderList: ["Mann", "Frau"],
      gender: this.$store.getters["search/filterprop"]("interested_in_gender"),
      age: this.$store.getters["search/filterprop"]("age"),
      isOnline: this.$store.getters["search/filterprop"]("is_online"),
      hasPicture: this.$store.getters["search/filterprop"]("has_picture"),
      hasEroticPicture: this.$store.getters["search/filterprop"](
        "has_erotic_picture"
      ),
      order: this.$store.getters["search/filterprop"]("order"),
      distance: this.$store.getters["search/filterprop"]("distance"),
      postcode: this.$store.getters["search/filterprop"]("postcode")
    };
  },
  created() {
    let me = this.$store.getters["user/me"]
      ? this.$store.getters["user/me"].customer_profile
      : null;
    if (
      me &&
      localStorage.getItem(`${this.$store.getters["user/me"].id}-postcode`)
    ) {
      this.postcode = localStorage.getItem(
        `${this.$store.getters["user/me"].id}-postcode`
      );
      this.$store.commit("search/updateFilter", {
        key: "postcode",
        value: localStorage.getItem(
          `${this.$store.getters["user/me"].id}-postcode`
        )
      });
      localStorage.removeItem(this.$store.getters["user/me"].id + "-postcode");
    }
    if (
      me &&
      localStorage.getItem(
        `${this.$store.getters["user/me"].id}-interested_in_gender`
      )
    ) {
      this.$store.commit("search/interested_in_gender", {
        key: "interested_in_gender",
        value: localStorage.getItem(
          `${this.$store.getters["user/me"].id}-interested_in_gender`
        )
      });
      localStorage.removeItem(
        this.$store.getters["user/me"].id + "-interested_in_gender"
      );
    }

    if (
      me &&
      me.interested_in_gender &&
      !this.$store.getters["search/filterprop"]("interested_in_gender")
    ) {
      let interested_in_gender = [];
      interested_in_gender.push(me.interested_in_gender[0] == "Frau" ? 1 : 0);
      if (me.interested_in_gender[1]) {
        interested_in_gender.push(me.interested_in_gender[0] == "Frau" ? 1 : 0);
      }
      this.$store.commit("search/updateFilter", {
        key: "interested_in_gender",
        value: interested_in_gender
      });
    }

    if (!this.$store.getters["search/filterprop"]("interested_in_gender")) {
      this.$store.commit("search/updateFilter", {
        key: "interested_in_gender",
        value: []
      });
    }

    this.gender = this.$store.getters["search/filterprop"](
      "interested_in_gender"
    );

    if (me && !this.postcode && me.zipcode) {
      this.postcode = me.zipcode + " (" + me.country + ", " + me.city + ")";
    }
  },
  methods: {
    search(data) {
      this.searching = true;
      this.$store.dispatch("search/read", data).finally(() => {
        this.searching = false;
      });
      if (!window.location.pathname.includes("search-user"))
        window.location.href = "/search-user/";
    },
    checkAuth(event, callback) {
      if (!this.$store.getters["user/auth"]) {
        event.preventDefault();
        event.stopPropagation();
        this.$store.dispatch("publicProfileModal/show", this.$modal);
        return false;
      }

      if (callback) {
        callback();
      }
    },
    applySearch() {
      this.$modal.hide(`modal-search-box`);
      this.search(this.filter);
    }
  },
  computed: {
    filter() {
      return {
        interested_in_gender: this.gender,
        age_from: this.age[0],
        age_to: this.age[1],
        is_online: this.isOnline,
        has_picture: this.hasPicture,
        has_erotic_picture: this.hasEroticPicture,
        order: this.order,
        location: "DE:23522",
        distance: this.distance,
        postcode: this.postcode,
        i_search_for_activity: [0, 1, 2, 3]
      };
    }
  }
};
</script>

<style lang="scss">
.user-search.autocomplete {
  z-index: 500;
  input.form-control {
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
  }
}
</style>
